(function($){
	$(document).on('focus', '.gfield:not(.form-hide-label) input', function(){
		$(this).closest('.gfield').addClass('is-active');
	});

	$(document).on('blur', '.gfield:not(.form-hide-label) input', function(){
		if($(this).val() === ''){
			$(this).closest('.gfield').removeClass('is-active');
		}
	});

	$(".active-filter:not( > i)").on('click', function(){
		$(this).closest('.filter-option-wrap').toggleClass('is-active');
	});

	var data = {
		action: 'generate_filter_results',
		resource_type : '',
		resource_service : '',
		resource_industry: ''
	};

	$(".filter-dropdown a").on('click', function(e){
		e.preventDefault();

		

		var $this = $(this);
		
		var value = $this.data('value');

		$this.closest('.filter-option-wrap').toggleClass('is-active');

		var string = $this.html();

		$this.closest('.filter-option-wrap').find('.active-filter-text').html(string);
		$this.closest('.filter-option-wrap').find('.active-filter').attr('data-value', value);

		if($this.closest('ul').attr('id') == 'resource-type-dropdown' ){
			data.resource_type = value;
		}
		if($this.closest('ul').attr('id') == 'service-dropdown'){
			data.resource_service = value;
		}
		if($this.closest('ul').attr('id') == 'industry-dropdown'){
			data.resource_industry = value;
		}

		

		
		setTimeout(function(){
			
			

			$.ajax({
			  type: 'post',
			  url: 'http://dev.ridgemarketing.com/satori/wp-admin/admin-ajax.php', // the localized name of your file
			  data: data,
			
			  // what happens on success
			  success: function( response ) {
			  	$(".panel--filter-results").removeClass('is-hidden');
			  	$(".panel--default-resources").addClass('is-hidden');
			  	$("#filter-results").html(response);


			  }
			
			});
		}, 100);
	});

	$("#filter-reset").on('click', function(){
		$(".panel--filter-results").addClass('is-hidden');
		$(".panel--default-resources").removeClass('is-hidden');
		$(".active-filter").each(function(){
			$(this).find('.active-filter-text').html($(this).data('default'));
			$(this).attr('data-value', '');
		});
	});


	function setDate() {

		var timezones = {
			'est' : moment.tz('America/New_York'), 
			'cst' : moment.tz('America/Chicago'), 
			'hkt' : moment.tz('Asia/Hong_Kong'), 
			'gmt' : moment.tz('Europe/London'), 
			'pst' : moment.tz('America/Los_Angeles')
		};

		for (var time in timezones){
			$('.clock[data-tz="' + time + '"]').each(function(i, clock){
				var $clock = $(clock);
				var seconds = timezones[time].seconds();
				var mins = timezones[time].minutes();
				var hour = timezones[time].hours();
				
				var minsDegrees = ((mins / 60) * 360) + ((seconds/60)*6) - 90;
				$clock.find('.minute-hand').css({
					transform: 'rotate(' + minsDegrees + 'deg)'
				});

				var hourDegrees = ((hour / 12) * 360) + ((mins/60)*30) - 90;
				$clock.find('.hour-hand').css({
					transform: 'rotate(' + hourDegrees + 'deg)'
				});
			});
		}
	}

	if($('clocks')){
		setDate();
	}

	$(".js_show-search").on('click', function(){
		$(".search-container").toggleClass('is-showing');
	});

	//Accessibility

	// Properly update the ARIA states on focus (keyboard) and mouse over events
	  $( '[role="menubar"]' ).on( 'focus.aria  mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
	    $( ev.currentTarget ).attr( 'aria-expanded', true );
	  } );

	  // Properly update the ARIA states on blur (keyboard) and mouse out events
	  $( '[role="menubar"]' ).on( 'blur.aria  mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
	    $( ev.currentTarget ).attr( 'aria-expanded', false );
	  } );

	  // Focus styles for menus when using keyboard navigation

	  	// Properly update the ARIA states on focus (keyboard) and mouse over events
	  	$( 'nav > ul' ).on( 'focus.wparia  mouseenter.wparia', '[aria-haspopup="true"]', function ( ev ) {
	  		$( ev.currentTarget ).attr( 'aria-expanded', true );
	  	} );

	  	// Properly update the ARIA states on blur (keyboard) and mouse out events
	  	$( 'nav > ul' ).on( 'blur.wparia  mouseleave.wparia', '[aria-haspopup="true"]', function ( ev ) {
	  		$( ev.currentTarget ).attr( 'aria-expanded', false );
	  } );


	  //Accordian
	  $(".js-accordian-trigger").on('click', function(){
		  var $this = $(this);
		  var $indicator = $this.find(".accordian--indicator");
		  $this.next('.accordian--content').toggleClass('is-open');

		  if($('.accordian--content').hasClass('is-open')){
			$indicator.html('-');
		  }
		  else{
			  $indicator.html('+');
		  }
	  });

	//Mobile menu toggle
	$(".menu-icon-wrap").on('click', function(){
		$(".main-nav-wrap").toggleClass("showing");
		var $this = $(this);
		if($this.hasClass("showing")){
		$this.removeClass("showing").find('.label').html("Menu");
		}
		else{
		$this.addClass("showing").find('.label').html("Close");
		}
	});

	$(window).on('load', function(){
		$(".main-nav-wrap .menu-item-has-children > a").after("<span class='nav-toggle'><i class='fa fa-plus'></i></span>");
		$(".nav-toggle").on('click', function(){
			var $this = $(this);
			var $parent = $this.closest('li');
			var $nav = $parent.children("ul");
	
			$nav.slideToggle();
			$parent.toggleClass('toggled');
			if ($this.find('.fa').hasClass('fa-plus')){
			  $this.find('.fa').removeClass('fa-plus').addClass('fa-minus');
			}
			else{
			  $this.find('.fa').removeClass('fa-minus').addClass('fa-plus');
			}
		});
	  });

	

	var waypoints = $('.animate').waypoint({
		handler: function(direction) {
			if(direction == 'down'){
				$(this.element).addClass('animated');
			}
		},
		offset: '85%'
	});

	$(window).on('load', function(){
		$(".hero--home h1, .hero--home p, .btn").addClass('animated');
	});
})(jQuery);